import type React from 'react';

import { useConsultation } from '@entities/consultations';

import { Avatar } from '@mui/material';

import * as st from './styles.module.scss';

type Props = {
	id: number;
};

export const ConsultationSeller: React.FC<Props> = ({ id }) => {
	const { consultation } = useConsultation(id);

	const getName = () => {
		if (!consultation || !consultation.coach) return;
		const { coach } = consultation;
		return `${coach.last_name} ${coach.first_name} ${coach.middle_name ?? ''}`;
	};

	return (
		<div className={st.user}>
			<Avatar sx={{ width: 40, height: 40 }} src={consultation?.coach.photo}>
				{consultation?.coach.last_name?.slice(0, 1)}
			</Avatar>
			<div className={st.user__name}>{getName()}</div>
		</div>
	);
};
